'use client';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useRef, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import PickerCircle from './PickerCircle';
import { hsvToRgb, rgbToHex, getHueColor } from './colorUtils';
var Container = styled(Box)(function (_ref) {
    var theme = _ref.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '238px',
        flexShrink: 0,
        position: 'relative',
        cursor: 'crosshair'
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '180px'
    });
});
var TopRightCornerColor = styled(Box)(function (_ref3) {
    var theme = _ref3.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '238px',
        flexShrink: 0,
        borderRadius: '8px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        position: 'absolute',
        left: 0,
        top: 0
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '180px'
    });
});
var SaturationOverlay = styled(Box)(function (_ref5) {
    var theme = _ref5.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '238px',
        flexShrink: 0,
        borderRadius: '8px',
        background: 'linear-gradient(90deg, #fff 0%, rgba(255, 255, 255, 0) 100%)',
        position: 'absolute',
        left: 0,
        top: 0
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '180px'
    });
});
var BrightnessOverlay = styled(Box)(function (_ref7) {
    var theme = _ref7.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: '238px',
        flexShrink: 0,
        borderRadius: '8px',
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%)',
        position: 'absolute',
        left: 0,
        top: 0
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '100%'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '180px'
    });
});
var StyledPickerCircle = styled(PickerCircle)(function (_ref9) {
    var x = _ref9.x, y = _ref9.y, theme = _ref9.theme;
    return _defineProperty({
        left: "".concat(x - 16, "px"),
        top: "".concat(y - 16, "px"),
        cursor: 'grab',
        '&:active': {
            cursor: 'grabbing'
        }
    }, theme.breakpoints.down('sm'), {
        left: "".concat(x - 12, "px"),
        top: "".concat(y - 12, "px")
    });
});
var ColorPickerArea = function ColorPickerArea(_ref1) {
    var currentColor = _ref1.currentColor, onChange = _ref1.onChange, pickerPosition = _ref1.pickerPosition, onPositionChange = _ref1.onPositionChange;
    var containerRef = useRef(null);
    var handleMouseDown = useCallback(function (event) {
        if (!containerRef.current)
            return;
        var rect = containerRef.current.getBoundingClientRect();
        var x = Math.max(0, Math.min(319, event.clientX - rect.left));
        var y = Math.max(0, Math.min(238, event.clientY - rect.top));
        var saturation = Math.round(x / 319 * 100);
        var brightness = Math.round((238 - y) / 238 * 100);
        var rgb = hsvToRgb(currentColor.hsv.h, saturation, brightness);
        var hex = rgbToHex(rgb.r, rgb.g, rgb.b);
        onPositionChange({
            x: x,
            y: y
        });
        onChange === null || onChange === void 0 || onChange({
            hex: hex,
            rgb: rgb,
            hsv: {
                h: currentColor.hsv.h,
                s: saturation,
                v: brightness
            }
        });
        var handleMouseMove = function handleMouseMove(moveEvent) {
            var newX = Math.max(0, Math.min(319, moveEvent.clientX - rect.left));
            var newY = Math.max(0, Math.min(238, moveEvent.clientY - rect.top));
            var newSaturation = Math.round(newX / 319 * 100);
            var newBrightness = Math.round((238 - newY) / 238 * 100);
            var newRgb = hsvToRgb(currentColor.hsv.h, newSaturation, newBrightness);
            var newHex = rgbToHex(newRgb.r, newRgb.g, newRgb.b);
            onPositionChange({
                x: newX,
                y: newY
            });
            onChange === null || onChange === void 0 || onChange({
                hex: newHex,
                rgb: newRgb,
                hsv: {
                    h: currentColor.hsv.h,
                    s: newSaturation,
                    v: newBrightness
                }
            });
        };
        var _handleMouseUp = function handleMouseUp() {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', _handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', _handleMouseUp);
    }, [currentColor.hsv.h, onChange, onPositionChange]);
    var hueColor = getHueColor(currentColor.hsv.h);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ React.createElement(TopRightCornerColor, {
        sx: {
            backgroundColor: hueColor
        }
    }), /*#__PURE__*/ React.createElement(SaturationOverlay, null), /*#__PURE__*/ React.createElement(BrightnessOverlay, null), /*#__PURE__*/ React.createElement(StyledPickerCircle, {
        color: currentColor.hex,
        className: "picker-circle-main",
        x: pickerPosition.x,
        y: pickerPosition.y
    }));
};
export default ColorPickerArea;
